import { Moment } from "moment";
import { useCallback, useEffect, useState } from "react";
import api from "api";
import "./classifications.scss";
import ClassificationCard from "./classification-card";
import Heatmap from "../heatmap";
import ClassificationDailyInsights from "./classification-daily-insights/classification-daily-insights";

function Classifications({ projectId, dateFrom, dateTo, streamIds }: { projectId: number; dateFrom: Moment; dateTo: Moment; streamIds: number[] }) {
  const [clips, setClips] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [clipCount, setClipCount] = useState<number[]>([]);
  const [totalAve, setTotalAve] = useState<number[]>([]);
  const reducer = (prev: number, current: number) => prev + current;

  const mediaCat = ["None", "Owned", "Earned", "Chatter"];

  const getBrandAssoc = (id: number) => {
    switch (id) {
      case 0:
        return "none";
      case 1:
        return "Owned";
      case 2:
        return "Earned";
      case 3:
        return "Chatter";
    }
  };

  const getClips = useCallback(async () => {
    setLoading(true);
    const data = await api.clip.getAll(projectId, dateFrom, dateTo, streamIds.join(","));
    mediaCat.forEach((category: string, index: number) => {
      let filtered = data.filter((item: any) => item.BrandAssociationId === index);
      let _totalAve: any[] = [];
      filtered.forEach((item: any) => {
        _totalAve.push(item.AVE);
      });
      if (_totalAve.length > 0) {
        let foo = _totalAve.reduce(reducer);
        setTotalAve((totalAve) => [...totalAve, foo]);
      }
      setClipCount((clipCount) => [...clipCount, filtered.length]);
    });
    setClips(data);
    setLoading(false);
  }, [projectId, dateFrom, dateTo, streamIds, setTotalAve]);

  useEffect(() => {
    getClips();
  }, [getClips]);

  return (
    <>
      <div className="classifications">
        <ClassificationCard loading={loading} brandAssocId={1} clipCount={clipCount[0]} ave={totalAve[0] ? totalAve[0] : 0} />
        <ClassificationCard loading={loading} brandAssocId={2} clipCount={clipCount[1]} ave={totalAve[1] ? totalAve[1] : 0} />
        <ClassificationCard loading={loading} brandAssocId={3} clipCount={clipCount[2]} ave={totalAve[2] ? totalAve[2] : 0} />
        <ClassificationCard loading={loading} brandAssocId={0} clipCount={clipCount[0] + clipCount[1] + clipCount[2]} ave={clips.find((x: any) => x.BrandAssociationId === 3)?.AVE || 0} />
      </div>
      <Heatmap projectId={projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds} />
      <ClassificationDailyInsights projectId={projectId} dateFrom={dateFrom} dateTo={dateTo} counts={[(clipCount[0] | 0) + (clipCount[1] | 0) + (clipCount[2] | 0), (clipCount[0] | 0), (clipCount[1] | 0), (clipCount[2] | 0)]}></ClassificationDailyInsights>
    </>
  );
}

export default Classifications;
